import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature } from '@openfeature/react-sdk';

// Release gate for the four copy-settings toggles on text-menu selection copy (vMarkdown,
// markdown-native); OFF falls back to WITH_LISTS. Shortcut copy, cut and context menu are ungated.
// Standalone module, not the `index.tsx` barrel, to avoid a react-refresh lint warning.
export const isSelectionCopySettingsEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-selection-copy-settings',
    false
  );
